import * as z from 'zod'
import { BooleanZod, BooleanOpcionalZod, IDTextualZod, NumeroZod, NumeroOpcionalZod, StringOpcionalZod, StringZod, BooleanOVerdaderoZod } from './zodComun'
import { FechaZod } from './fechas'
import { IdiomasDisponiblesZod } from './idiomas'
import { DispositivoZod, ModoZod } from './dispositivo'
export { DispositivoZod, ModoZod } from './dispositivo'
export type { Dispositivo, Modo } from './dispositivo'
const InterfazAppZod = z.enum(['a', 'b', 'libre'])

export const AppListadaZod = z.object({
  appID: StringZod,
  nombre: StringZod,
  descripcion: StringZod,

  hosts: z.array(StringZod),
  host: StringZod,
  androidLink: StringOpcionalZod,
  iosLink: StringOpcionalZod,
  gimnasioBMIDs: z.array(NumeroZod),

  logo: StringOpcionalZod,
  logoDark: StringOpcionalZod,

  deprecar: BooleanOpcionalZod
})
export type AppListada = z.infer<typeof AppListadaZod>

export const AppListadaConGimIDsZod = AppListadaZod.extend({
  gimnasioIDs: z.array(IDTextualZod)
})
export type AppListadaConGimIDs = z.infer<typeof AppListadaConGimIDsZod>

export const ListadoDeAppsZod = z.record(z.string(), AppListadaConGimIDsZod)
export type ListadoDeApps = z.infer<typeof ListadoDeAppsZod>

export const TextosDeAppZod = z.object({ fraseInicio: StringZod }).optional()

export const AppConfigFrontZod = z.object({
  appID: StringZod,
  nombre: StringZod,
  descripcion: StringZod,

  hosts: z.array(StringZod),
  host: StringZod,

  androidLink: StringOpcionalZod,
  iosLink: StringOpcionalZod,

  bundleID: StringZod,
  tema: z.enum(['claro', 'oscuro']).optional(),

  splashFondo: StringZod,
  splashFondoOscuro: StringZod,

  permisosDeAnonimo: z.object({
    crearCuenta: BooleanOpcionalZod,
    ingresar: BooleanOVerdaderoZod,
    cambiarPass: BooleanOpcionalZod
  }),

  textos: TextosDeAppZod,

  preferencias: z.object({
    requiereAutorizacion: BooleanZod
  }).optional(),

  cloudflareTurnstileSiteKey: StringOpcionalZod,

  baseDeDatos: StringOpcionalZod,
  applicationServerKey: StringOpcionalZod,

  instagram: StringOpcionalZod,
  pais: StringOpcionalZod,
  idiomaPorDefecto: IdiomasDisponiblesZod.optional(),

  gimnasioIDs: z.array(StringZod).optional(),

  interfazApp: InterfazAppZod.optional(),

  cacheDeSesion: BooleanOpcionalZod,

  flujoCalificacionApp: z.object({
    activo: BooleanZod
  }).default({ activo: false }),

  imagenOG: StringOpcionalZod,
  imagenOGAncho: NumeroOpcionalZod,
  imagenOGAlto: NumeroOpcionalZod,
  themeColor: StringOpcionalZod,
  iconoApple: StringOpcionalZod,

  gTagManager: z.string().nullable().optional()
})

export type AppConfigFront = z.infer<typeof AppConfigFrontZod>

export const BuildConfigFrontZod = z.object({
  dispositivo: DispositivoZod,
  modo: ModoZod,
  version: StringZod,
  versionCode: NumeroZod,
  dev: z.boolean(),
  apiUrl: z.string(),
  appUrl: z.string().optional(),
  adminUrl: z.string(),

  fechaDeCompilacion: FechaZod
})
export type BuildConfigFront = z.infer<typeof BuildConfigFrontZod>

export const ContextoAppZod = z.object({
  appConfig: AppConfigFrontZod,
  buildConfig: BuildConfigFrontZod
})
export type ContextoApp = z.infer<typeof ContextoAppZod>

export const EstadoVersionNormalizadoZod = z.enum([
  'borrador',
  'enRevision',
  'publicado',
  'rolloutParcial',
  'pausado',
  'rechazado',
  'fallo',
  'desconocido'
])
export type EstadoVersionNormalizado = z.infer<typeof EstadoVersionNormalizadoZod>

export const VersionInfoZod = z.object({
  texto: StringZod,
  estado: StringZod,
  estadoNormalizado: EstadoVersionNormalizadoZod.optional(),
  versionSemver: StringOpcionalZod,
  versionNumerica: StringOpcionalZod,
  porcentajeRollout: z.number().min(0).max(1).optional(),
  fechaCreacion: StringOpcionalZod,
  fechaFinDeploy: StringOpcionalZod,
  releaseType: StringOpcionalZod,
  inAppUpdatePriority: z.number().min(0).max(5).optional()
})
export type VersionInfo = z.infer<typeof VersionInfoZod>

export const AppVersionesZod = z.object({
  android: z.object({
    production: VersionInfoZod,
    internal: VersionInfoZod
  }),
  ios: z.object({
    production: VersionInfoZod,
    internal: VersionInfoZod
  }),
  pages: z.object({
    production: VersionInfoZod,
    internal: VersionInfoZod
  })
})
export type AppVersiones = z.infer<typeof AppVersionesZod>

export const AppListadaConVersionesZod = AppListadaConGimIDsZod.extend({
  versiones: AppVersionesZod
})
export type AppListadaConVersiones = z.infer<typeof AppListadaConVersionesZod>